(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('offersService', offersService);

  function offersService(
    $http, 
    ngAuthSettings,
    promiseCacheService,
    userSettingsService
  ) {
    'ngInject';

    const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

    const service = {
      getCampaignOffers: getCampaignOffers,
      getAllOffers: getAllOffers,
      getCampaignOfferDetails: getCampaignOfferDetails,
      joinCampaignOffer: joinCampaignOffer,
      getCampaignOfferPublisherNumbers: getCampaignOfferPublisherNumbers,
      addCampaignOfferPublisherNumbers: addCampaignOfferPublisherNumbers,
      leaveCampaignOffer: leaveCampaignOffer,
      hideCampaignOffer: hideCampaignOffer,
      unhideCampaignOffer: unhideCampaignOffer,
      getOfferParticipants: getOfferParticipants,
      saveDraftOffer: saveDraftOffer,
      deleteDraftOffer: deleteDraftOffer,
      publishDraftOffer: publishDraftOffer,
      pausePublishedOffer: pausePublishedOffer,
      resumePublishedOffer: resumePublishedOffer,
      deletePublishedOffer: deletePublishedOffer,
      invitePublisher: invitePublisher,
      initNextSteps: initNextSteps
    };

    return service;

    function getAllOffers(accountId, includeHidden) {
      return $http.get(_serviceBaseAccountUrlForOffers(accountId) + '?includeHidden=' + includeHidden);
    }

    function getCampaignOffers(accountId, campaignId) {
      return $http.get(_serviceBaseUrl(accountId, campaignId));
    }

    function getCampaignOfferDetails(accountId, campaignId) {
      return $http.get(_serviceBaseAccountUrlForOffers(accountId, campaignId));
    }

    function getCampaignOfferPublisherNumbers(accountId, campaignId) {
      return $http.get(_serviceBaseAccountUrlForOffers(accountId, campaignId) + '/number');
    }

    function addCampaignOfferPublisherNumbers(accountId, campaignId, number) {
      const data = number.assignmentSettings;
      data.countryCode = number.campaign.countryCode;
      return $http.post(_serviceBaseAccountUrlForOffers(accountId, campaignId) + '/number', data);
    }

    function joinCampaignOffer(accountId, campaignId, message) {
      return $http.post(_serviceBaseAccountUrlForOffers(accountId, campaignId) + '/join', {
        message: message
      });
    }

    function leaveCampaignOffer(accountId, campaignId, message) {
      return $http.post(_serviceBaseAccountUrlForOffers(accountId, campaignId) + '/leave', {
        message: message
      });
    }

    function hideCampaignOffer(accountId, campaignId) {
      return $http.post(_serviceBaseAccountUrlForOffers(accountId, campaignId) + '/hide');
    }

    function unhideCampaignOffer(accountId, campaignId) {
      return $http.post(_serviceBaseAccountUrlForOffers(accountId, campaignId) + '/unhide');
    }

    function getOfferParticipants(accountId, campaignId) {
      const url = _serviceBaseUrl(accountId, campaignId) + '/published/participants';
      const cacheKey = 'getOfferParticipants' + campaignId;
      return promiseCacheService.getCallWithCachedPromise(cacheKey, url, 30);
    }

    function saveDraftOffer(accountId, campaignId, offer) {
      const url = _serviceBaseUrl(accountId, campaignId) + '/draft';
      return $http.put(url, offer);
    }

    function deleteDraftOffer(accountId, campaignId) {
      const url = _serviceBaseUrl(accountId, campaignId) + '/draft';
      return $http.delete(url);
    }

    function publishDraftOffer(accountId, campaignId) {
      const url = _serviceBaseUrl(accountId, campaignId) + '/draft/publish';
      return $http.post(url);
    }

    function pausePublishedOffer(accountId, campaignId) {
      const url = _serviceBaseUrl(accountId, campaignId) + '/published/pause';
      return $http.post(url);
    }

    function resumePublishedOffer(accountId, campaignId) {
      const url = _serviceBaseUrl(accountId, campaignId) + '/published/resume';
      return $http.post(url);
    }

    function deletePublishedOffer(accountId, campaignId, keepNumbers) {
      const url = _serviceBaseUrl(accountId, campaignId) + '/published?keepNumbers=' + keepNumbers;
      return $http.delete(url);
    }

    function invitePublisher(accountId, campaignId, publisherId, message) {
      const url = _serviceBaseUrl(accountId, campaignId) + '/published/invite';
      const data = {
        publisherId: publisherId,
        message: message
      };
      return $http.post(url, data);
    }

    function initNextSteps(campaignId) {
      return userSettingsService.getUserSettings().then(function (settings) {
        if (!settings.neverShowOfferNextSteps) {
          if (!settings.offerNextSteps) {
            settings.offerNextSteps = {};
          } 
          if (typeof settings.offerNextSteps[campaignId] !== 'boolean') {
            settings.offerNextSteps[campaignId] = true;
          }
          return userSettingsService.saveUserSettings(settings);
        }
      });
    }

    function _serviceBaseAccountUrlForOffers(accountId, campaignId) {
      return serviceBaseUri + accountId + '/offers' + (campaignId ? '/' + campaignId : '');
    }

    function _serviceBaseUrl(accountId, campaignId) {
      return serviceBaseUri + accountId + '/campaigns/' + campaignId + '/offers';
    }
    
  }
})();
